import { FormEvent } from "react";
import useListRowInfStroe from "store/listRowInf";
import {
  initialFilterStateProps,
  useUserFilterContext,
  useUserParamsContext,
} from "./context";

export const useSubmit = () => {
  const { filters } = useUserFilterContext();
  const { setParam } = useUserParamsContext();
  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    let param = {} as Partial<initialFilterStateProps>;
    (Object.keys(filters) as Array<keyof initialFilterStateProps>).forEach(
      (key) => {
        if (key === "uYn") {
          param = {
            ...param,
            [filters.uYn]: "Y",
          };
          return;
        }
        if (filters[key] !== "" && filters[key] !== undefined) {
          param = {
            ...param,
            [key]: filters[key],
          };
        }
      }
    );
    setParam(param);
  };

  return {
    onSubmit,
  };
};

// 상세
export const detail = (props: any) => {
  const setListRowParams = useListRowInfStroe.getState().setListRowParams;
  const params = {
    no: props.data.memNo,
    rgSeq: 1,
    btnNm: props.colDef.field,
  };
  setListRowParams(params);
};
